/**
 * Investigator status — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const INVESTIGATOR_STATUS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PENDING: "Pending",
} as const;

export type InvestigatorStatus =
  (typeof INVESTIGATOR_STATUS)[keyof typeof INVESTIGATOR_STATUS];

const helpers = createStatusHelpers(
  INVESTIGATOR_STATUS,
  INVESTIGATOR_STATUS.ACTIVE,
);

export const INVESTIGATOR_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeInvestigatorStatus = helpers.tryNormalize;
export const normalizeInvestigatorStatus = helpers.normalize;
export const isInvestigatorStatus = helpers.isStatus;
export const isAnyInvestigatorStatus = helpers.isAnyStatus;
